import React from 'react';
import axios from 'axios';
import { get } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withRouter, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Form } from 'informed';
import { API_URL } from '../../lib/const';
import BaseEnrollmentSummary from './BaseEnrollmentSummary';
import { FieldSet, InputTypeArea, Spinner } from '../elements';
import { getAxiosConfig } from '../../lib/auth';
import { Modal } from '../components';
import ComponentWithToken from '../components/CompontentWithToken';
import ConfirmationModal from '../components/ConfirmationModal';
import ContractMonitor from '../components/ContractMonitor';
import {
  ENROLLMENT_STATUS,
  CONTRACT_STATUS,
  NEW_BOLETO_STATUS,
  FINALIZE_ENROLLMENT_STATUS,
  PAYMENT_STATUS
} from '../../lib/config';
import { approvalData, sendContract } from '../services/approval_services';
import DownloadButton from '../components/DownloadButton';
import withPermission from '../../hoc/withPermission';
import { generateBoleto } from '../services/finance_data_service';
import { approveDocumentData } from '../services/documents_services';
import ListBoleto from '../components/boleto/ListBoleto';
import EnrollmentSummaryPendencies from './EnrollmentSummaryPendencies';
import {
  canFinalizeEnrollment,
  isContractFinalized,
  isDocumentApproved,
  isPaymentFinalizedOrExempt
} from './enrollmentSummaryFinancerChecks';

class EnrollmentSummaryFinancer extends ComponentWithToken {
  state = {
    loading: true,
    data: undefined,
    financeData: undefined,
    fileSrc: null,
    content: [],
    contract: undefined,
    fields: {},
    options: {},
    resubmittingInvoice: false,
    resubmittingContract: false,
    showResubmit: false,
    shouldApproveStudent: false,
    showConfirmationModal: false,
    showConfirmationModalProof: false,
    invoices: [],
    boleto_id: null,
    submittingBoleto: false,
    showResolvePendencyModal: false,
    selectedPendencyId: null,
    updatingPendencies: false,
    showConfirmationModalFinalize: false,
    complementaryBoletos: [],
    editPendency: false,
    changedPendencyData: {},
    confirmDeletePendency: false,
    enrollmentId: null,
    safe2pay_pagamento: null,
    isExempt: false,
    approvingDocumentStatus: false
  };

  componentDidMount() {
    Promise.all([
      this.fetchData(),
      this.fetchFinanceData(),
      this.fetComplementaryBoletos(),
      this.fetchEnrollExemptStatus()
    ]).then(() => this.setState({ loading: false }));
  }

  fetchEnrollExemptStatus = () =>
    axios
      .get(`${API_URL}/onboarding/enroll/${this.token}`)
      .then(response => {
        const paymentStatusId = get(response, 'data.payment_status_id');
        const isCourseExempt = get(response, 'data.is_course_exempt');
        const showProof = get(response, 'data.show_proof');
        this.setState({
          isExempt:
            paymentStatusId === PAYMENT_STATUS.EXEMPT ||
            isCourseExempt ||
            showProof === false
        });
      })
      .catch(() => {});

  fetComplementaryBoletos = () => {
    axios
      .get(`${API_URL}/onboarding/complementary-boletos/${this.token}`)
      .then(response => this.setState({ complementaryBoletos: response.data }));
  };

  fetchData = () => {
    const { getData } = this.props;
    axios
      .get(`${API_URL}/onboarding/personal-data/${this.token}/summary`)
      .then(response => {
        const { data } = response;
        this.setState({
          data,
          loading: false,
          enrollmentId: data.enrollment.id,
          options: {
            autoSave:
              get(data, 'enrollment.status.id') === ENROLLMENT_STATUS.REVIEWING,
            forwardedInvoice:
              get(data, 'enrollment.status.id') ===
              ENROLLMENT_STATUS.WAITING_PAYMENT,
            show: ![
              ENROLLMENT_STATUS.FILLING,
              ENROLLMENT_STATUS.ACCESSED,
              ENROLLMENT_STATUS.NOT_STARTED
            ].includes(get(data, 'enrollment.status.id')),
            disabled: [
              ENROLLMENT_STATUS.PAYMENT_REVIEWING,
              ENROLLMENT_STATUS.FINALIZED
            ].includes(get(data, 'enrollment.status.id'))
          },
          showResubmit:
            get(data, 'enrollment.status.id') !== ENROLLMENT_STATUS.FINALIZED,
          shouldApproveStudent:
            get(data, 'enrollment.contract_status.id') === CONTRACT_STATUS.DONE
        });
        this.fetchContractDetails();
        this.fetchPaymentProof();
        getData(data.enrollment.id, data.enrollment.status.id);
      })
      .catch(() => {
        this.setState({
          loading: false
        });
      });
  };

  fetchFinanceData() {
    axios
      .get(`${API_URL}/finance/finance-data/${this.token}/summary`)
      .then(response =>
        this.setState({
          invoice: get(response.data, 'invoice'),
          invoices: get(response.data, 'invoices'),
          boleto_id: get(response.data, 'boleto_id'),
          safe2pay_pagamento: get(response.data, 'safe2pay_pagamento')
        })
      );
  }

  fetchContractDetails = () => {
    axios
      .get(`${API_URL}/contracts/enrollment/${this.token}`, getAxiosConfig())
      .then(response => {
        this.setState({ contract: response.data });
      });
  };

  fetchPaymentProof = () => {
    this.setState();
    axios.get(`${API_URL}/onboarding/enroll/${this.token}`).then(response => {
      this.setState({ proof_sent: response.data.proof_sent });
    });
  };

  fetchCleanPaymentProof = () => {
    this.setState({ loading: true, showConfirmationFinishModal: false });
    axios
      .patch(`${API_URL}/onboarding/enroll/${this.token}/clean_payment_proof`)
      .then(response => {
        toast.success('Comprovante apagado com sucesso!');
        this.setState({ loading: false });
        this.fetchPaymentProof();
      })
      .catch(error => {
        console.error('Erro ao limpar comprovante:', error.response);
        toast.error(error.response);
        this.setState({ loading: false });
      });
  };

  resubmitContract = () => {
    this.setState({ resubmittingContract: true });
    sendContract(this.token).finally(() =>
      this.setState({ resubmittingContract: false }, this.componentDidMount)
    );
  };

  handleConfirmationModalProof = () => {
    const { showConfirmationModalProof } = this.state;
    this.setState({ showConfirmationModalProof: !showConfirmationModalProof });
  };

  handleConfirmationModalFinalize = () => {
    const { showConfirmationModalFinalize } = this.state;
    this.setState({
      showConfirmationModalFinalize: !showConfirmationModalFinalize
    });
  };

  handleConfirmationModal = () => {
    const { showConfirmationModal } = this.state;
    this.setState({ showConfirmationModal: !showConfirmationModal });
  };

  handleApprove = () => {
    this.setState({ loading: true, showConfirmationModal: false });
    approvalData(this.token)
      .then(() => this.componentDidMount())
      .catch(() => this.setState({ loading: false }));
  };

  handleApproveProof = () => {
    this.setState({ loading: true, showConfirmationModalProof: false });
    const data = { approve_proof: true };
    axios
      .post(`${API_URL}/onboarding/proof-of-payment/${this.token}`, data)
      .then(() => {
        toast.success('Comprovante de pagamento aprovado', {
          position: toast.POSITION.BOTTOM_RIGHT
        });
        this.fetchData();
      })
      .catch(error => {
        toast.error(
          get(error, 'response.data[0]', 'Ocorreu um erro inesperado'),
          { position: toast.POSITION.BOTTOM_RIGHT }
        );
        this.setState({
          loading: false
        });
      });
  };

  handleFinalizeContract = () => {
    this.setState({ loading: true, showConfirmationModalProof: false });
    const data = { approve_proof: true };
    axios
      .post(
        `${API_URL}/onboarding/enrollments/${this.token}/finalize_enrollment`,
        data
      )
      .then(() => {
        toast.success('Contrato finalizado', {
          position: toast.POSITION.BOTTOM_RIGHT
        });
        this.fetchData();
      })
      .catch(error => {
        toast.error(
          get(error, 'response.data.message', 'Ocorreu um erro inesperado'),
          { position: toast.POSITION.BOTTOM_RIGHT }
        );
        this.setState({
          loading: false
        });
      });
  };

  handleDocumentStatusApproval = event => {
    if (!event.target.checked) {
      return;
    }

    this.setState({ approvingDocumentStatus: true });
    approveDocumentData(this.token)
      .then(() => {
        toast.success('Status do documento aprovado', {
          position: toast.POSITION.BOTTOM_RIGHT
        });
        return this.fetchData();
      })
      .catch(error => {
        toast.error(
          get(error, 'response.data.message', 'Ocorreu um erro inesperado'),
          { position: toast.POSITION.BOTTOM_RIGHT }
        );
      })
      .finally(() => {
        this.setState({ approvingDocumentStatus: false });
      });
  };

  generateBoleto = () => {
    this.setState({ submittingBoleto: false });
    generateBoleto(this.token).then(d => {
      this.setState({ submittingBoleto: false, boleto_id: d.boleto_id });
      toast.success('Boleto gerado com sucesso!');
    });
  };

  showModal = file => {
    axios.get(`${API_URL}/uploads/${file.key}`).then(response => {
      this.setState({
        showModal: true,
        content: file,
        fileSrc: get(response, 'data.url', null)
      });
    });
  };

  onClose = () => {
    this.setState({
      showModal: false
    });
  };

  handleJustifyPendency() {
    const { form, selectedPendencyId } = this.state;
    const { reloadPendencies } = this.props;
    this.setState({
      updatingPendencies: true,
      showResolvePendencyModal: false
    });
    axios
      .put(
        `${API_URL}/onboarding/pendencies/${selectedPendencyId}/justify`,
        form
      )
      .then(response => {
        this.setState({ updatingPendencies: false });
        reloadPendencies();
      })
      .catch(error => {
        toast.error(
          get(
            error,
            'response.data.justification[0]',
            'Ocorreu um erro inesperado'
          ),
          { position: toast.POSITION.BOTTOM_RIGHT }
        );
        this.setState({ updatingPendencies: false });
      });
  }

  renderPendencies() {
    const { pendencies, loadingPendencies, reloadPendencies } = this.props;
    const { updatingPendencies } = this.state;
    const showResolveForm = p => !p.resolved_at && p.financers_can_resolve;

    if (loadingPendencies || updatingPendencies) {
      return (
        <div className="text-center">
          <FontAwesomeIcon className="green" icon="spinner" pulse />
        </div>
      );
    }
    return pendencies.map(p => (
      <div className="pendencies" key={p.id}>
        <EnrollmentSummaryPendencies
          enrollmentId={this.state.enrollmentId}
          pendency={p}
          reloadPendencies={reloadPendencies}
        />
        {showResolveForm(p) && (
          <button
            className="btn btn-primary w-25"
            onClick={() =>
              this.setState({
                selectedPendencyId: p.id,
                showResolvePendencyModal: true
              })
            }
          >
            Justificar Pendência
          </button>
        )}
        <div className="pendencies-date" />
        <div className="pendencies-date">{p.created_at}</div>
      </div>
    ));
  }

  renderPreenchendo() {
    return (
      <>
        <FieldSet title="Em Andamento" />
        <div className="col-sm-12 col-md-6 mt-2">
          <p>O aluno ainda não enviou o formulário.</p>
        </div>
        <div className="text-right" style={{ marginBottom: '2.5rem' }}>
          <div className="col-md-3 p-0 offset-md-9 col-sm-12">
            <Link className="btn btn-primary" to="/financers">
              {' '}
              Voltar
            </Link>
          </div>
        </div>
      </>
    );
  }

  renderPendencias() {
    const { pendencies } = this.props;
    const checkNonResolvedPendencies =
      pendencies.filter(f => !f.resolved_at).length > 0;
    const checkPendencies = pendencies.length > 0;
    if (checkNonResolvedPendencies) {
      return (
        <>
          <FieldSet title="Em Andamento" />
          <div className="col-sm-12 col-md-6 mt-2">
            <p>O aluno ainda não resolveu as pendências.</p>
          </div>
          {this.renderPendencies()}
        </>
      );
    }
    if (checkPendencies) {
      return (
        <>
          <FieldSet title="Pendências" />
          {this.renderPendencies()}
        </>
      );
    }
    return null;
  }

  onSendPendencies = () => {
    const { handle } = this.props;
    handle().then(() => this.componentDidMount());
  };

  render() {
    const {
      loading,
      data,
      showModal,
      content,
      fileSrc,
      resubmittingContract,
      contract,
      showResubmit,
      showConfirmationModalFinalize,
      showConfirmationModal,
      showConfirmationModalProof,
      boleto_id,
      submittingBoleto,
      showResolvePendencyModal,
      complementaryBoletos,
      safe2pay_pagamento
    } = this.state;
    const {
      history,
      hasPermission,
      pendencies,
      hasPendencies,
      submittingPendencies,
      onDocumentApproval,
      onDocumentReproval
    } = this.props;
    const enrollmentStatus = get(data, 'enrollment.status.id', 1);
    const enrollment = get(data, 'enrollment', {});
    const regularStudent = !get(data, 'full_fies_or_prouni', false);
    const { isExempt, proof_sent } = this.state;
    const canFinalize = canFinalizeEnrollment(
      enrollment,
      proof_sent || isExempt
    );
    return (
      <>
        <Spinner active={loading}>
          <BaseEnrollmentSummary
            showActions
            token={this.token}
            onDocumentApproval={onDocumentApproval}
            onDocumentReproval={onDocumentReproval}
          />
          <ContractMonitor
            token={this.token}
            contract={contract}
            resubmitting={resubmittingContract}
            onResubmit={this.resubmitContract}
            showResubmit={showResubmit}
          />
          <Modal
            visible={showModal}
            onClose={this.onClose}
            title={content.name}
            src={fileSrc}
          />
          {enrollmentStatus === ENROLLMENT_STATUS.FILLING &&
            this.renderPreenchendo()}
          {NEW_BOLETO_STATUS.includes(enrollmentStatus) && (
            <>
              {isExempt && (
                <>
                  <FieldSet title="Pagamento" />
                  <p>Esta matrícula possui isenção de pagamento.</p>
                </>
              )}
              {/* QUANDO O BOLETO NAO TA VENCIDO */}
              {!isExempt &&
                regularStudent &&
                (boleto_id || safe2pay_pagamento) && (
                  <ListBoleto
                    boleto={boleto_id}
                    showResubmit
                    resubmitting={submittingBoleto}
                    onResubmit={this.generateBoleto}
                    complementaryBoletos={complementaryBoletos}
                    safe2payPagamento={safe2pay_pagamento}
                    userCanGenerateBoletos={
                      enrollmentStatus !== ENROLLMENT_STATUS.FINALIZED ||
                      hasPermission(
                        'onboarding.can_generate_boleto_before_overdue'
                      )
                    }
                  />
                )}
              {!isExempt &&
                regularStudent &&
                boleto_id && (
                  <>
                    <FieldSet title="Comprovante de Pagamento" />
                    <div
                      className="mt-3"
                      style={{ display: 'flex', gap: '0.75rem' }}
                    >
                      <div style={{ flex: 1 }}>
                        <a
                          href={`${API_URL}/finance/finance-data/${
                            this.token
                          }/download/proofs_of_payment`}
                          download
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-black link-unstyled"
                        >
                          Baixar comprovante(s) de pagamento
                        </a>
                      </div>
                      <div style={{ flex: 1 }}>
                        <button
                          onClick={this.fetchCleanPaymentProof}
                          className="btn btn-black"
                          disabled={loading || !this.state.proof_sent}
                        >
                          Desconsiderar comprovante de pagamento
                        </button>
                      </div>
                    </div>
                  </>
                )}
              {this.renderPendencias()}
              <hr />
              <div style={{ marginBottom: '2.5rem' }}>
                <div
                  className="mt-4"
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'flex-end',
                    gap: '0.75rem'
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-black"
                    style={{ width: 'auto' }}
                    onClick={() => history.push('/financers')}
                  >
                    Voltar
                  </button>
                  {hasPermission('contracts.approve_finance_data') &&
                    enrollmentStatus === ENROLLMENT_STATUS.REVIEWING &&
                    get(data, 'enrollment.kind') !== 'enroll_excess' && (
                      <>
                        {pendencies.filter(f => !f.resolved_at).length > 0 ||
                        hasPendencies ? (
                          <button
                            className="btn btn-primary"
                            type="submit"
                            style={{ width: 'auto' }}
                            disabled={
                              get(data, 'enrollment.status.id') === 3 ||
                              submittingPendencies
                            }
                            onClick={this.onSendPendencies}
                          >
                            Enviar todas pendências
                          </button>
                        ) : (
                          <button
                            className="btn btn-primary"
                            type="submit"
                            style={{ width: 'auto' }}
                            disabled={loading}
                            onClick={() => this.handleConfirmationModal()}
                          >
                            {loading ? 'Carregando' : 'Aprovar'}
                          </button>
                        )}
                      </>
                    )}
                  {FINALIZE_ENROLLMENT_STATUS.includes(enrollmentStatus) && (
                    <button
                      className="btn btn-primary"
                      type="submit"
                      style={{ width: 'auto' }}
                      disabled={loading || !canFinalize}
                      onClick={() => this.handleConfirmationModalFinalize()}
                    >
                      {loading ? 'Carregando' : 'Finalizar'}
                    </button>
                  )}
                </div>
              </div>
            </>
          )}
          {enrollmentStatus === ENROLLMENT_STATUS.PENDING ? (
            <>
              {this.renderPendencias()}
              <div
                className="text-right mt-3"
                style={{ marginBottom: '2.5rem' }}
              >
                <div className="col-md-3 p-0 offset-md-9 col-sm-12">
                  <Link className="btn btn-primary" to="/financers">
                    {' '}
                    Voltar
                  </Link>
                </div>
              </div>
            </>
          ) : (
            <></>
          )}
          {enrollmentStatus === ENROLLMENT_STATUS.FINALIZED && (
            <>
              {regularStudent && (
                <>
                  <FieldSet title="Comprovante de Pagamento" />
                  <DownloadButton
                    href={`${API_URL}/finance/finance-data/${
                      this.token
                    }/download/proofs_of_payment`}
                    label="Baixar comprovante(s) de pagamento"
                  />
                  <div className="w-50 mt-3">
                    <button
                      onClick={this.fetchCleanPaymentProof}
                      className="btn btn-black"
                      disabled={loading || !this.state.proof_sent}
                    >
                      Desconsiderar comprovante de pagamento
                    </button>
                  </div>
                </>
              )}
              <>
                <FieldSet title="Contrato" />
                <DownloadButton
                  label="Baixar Contrato"
                  href={`${API_URL}/contracts/enrollment/${
                    this.token
                  }/contract`}
                />
              </>
              <hr />
              <div className="mb-3">
                <div className="col-md-3 p-0 offset-md-9 col-sm-12">
                  <Link className="btn btn-primary" to="/financers">
                    {' '}
                    Voltar
                  </Link>
                </div>
              </div>
            </>
          )}
        </Spinner>
        <ConfirmationModal
          visible={showConfirmationModal}
          title="Confirmação"
          onCancel={() => this.handleConfirmationModal()}
          onConfirm={() => this.handleApprove()}
        >
          Você tem certeza que deseja aprovar o aluno? Se sim, o contrato e o
          boleto, se necessário, serão enviados para o aluno e seus fiadores.
        </ConfirmationModal>
        <ConfirmationModal
          visible={showConfirmationModalProof}
          title="Confirmação"
          onCancel={() => this.handleConfirmationModalProof()}
          onConfirm={() => this.handleApproveProof()}
        >
          Você tem certeza que deseja concluir o processo de rematrícula do
          aluno?
        </ConfirmationModal>
        <ConfirmationModal
          visible={showConfirmationModalFinalize}
          title="Finalizar contrato"
          onCancel={() => this.handleConfirmationModalFinalize()}
          onConfirm={() => this.handleFinalizeContract()}
        >
          Você tem certeza que deseja concluir o processo de matrícula do
          candidato ?
        </ConfirmationModal>
        <ConfirmationModal
          visible={showResolvePendencyModal}
          title="Justificar Pendência"
          onCancel={() => this.setState({ showResolvePendencyModal: false })}
          onConfirm={() => this.handleJustifyPendency()}
          cancelText="Cancelar"
          confirmText="Justificar"
        >
          <p>
            Ao justificar uma pendência o processo de rematrícula do aluno
            poderá continuar.
          </p>
          <Form onValueChange={form => this.setState({ form })}>
            <InputTypeArea
              className="p0"
              field="justification"
              label="Justificativa"
              row="4"
            />
          </Form>
        </ConfirmationModal>
      </>
    );
  }
}

export default withRouter(withPermission(EnrollmentSummaryFinancer));
